import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import NavTabs from "../../components/NavTabs";
import Sidebar from "../../components/SideBar";
import List from "../../components/List";
import Label from "../../components/Label";
import Button from "../../components/Button";
import tableIcons from "../../config/tableIcons";
// import Register from "./Register";

import { Dialog, DialogContent } from "@material-ui/core";

import Enroll from "../../services/enroll";

import { Line } from "./styles";
import Event from "../../services/event";
import AddActivity from "./AddActivity";

const Activities = () => {
    const [open, setOpen] = useState(false);
    const history = useHistory();

    const columns = [
        // { field: "id", title: "ID", type: "numeric" },
        { field: "name", title: "Nome" },
        { field: "description", title: "Descrição" },
        { field: "obs", title: "Observação" },
        // { field: "attachment", title: "Anexo" },
        { field: "enable", title: "Status" },
    ];

    const actions = [
        {
            icon: tableIcons.Delete,
            tooltip: "Deletar Atividade",
            disabled: true,
            onClick: (e, request) => {
                return Enroll.deleteUser(request.id)
                    .then((resp) => {
                        if (!!resp.response) {
                            console.log(resp.response.data.error);
                        } else {
                            console.log(resp.status);
                            window.location.reload();
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
        },
        {
            icon: tableIcons.Detail,
            tooltip: "Detalhes",
            onClick: (e, request) => {
                history.push(`/activity/detail/${request.id}`);
            },
        },
        {
            icon: tableIcons.Goto,
            tooltip: "Controle Atividade",
            onClick: (e, request) => {
                window.open(`/activity/${request.event_id}/${request.id}`, "_blank");
            },
        },
    ];

    const getRows = () => {
        return Event.getActivities()
            .then((resp) => {
                if (!!resp.data) return resp.data.data;
                return [];
            })
            .catch(function (error) {
                return [];
            });
    };

    const data = [
        {
            name: "Atividades",
            content: <List columns={columns} rows={[]} getRows={getRows} actions={actions} />,
        },
    ];

    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const page = (
        <>
            <Line>
                <Label className="first" size="min" color="dark" align="left" weight="500">
                    Atividades
                </Label>
                <div>
                    <Button size="nano" color="dark" format="solid" width="100%" onClick={handleOpen}>
                        Nova Atividade
                    </Button>
                </div>
            </Line>
            <Dialog open={open} onClose={handleClose}>
                <DialogContent>
                    <AddActivity close={handleClose} />
                </DialogContent>
            </Dialog>
            <div style={{ maxWidth: "100%" }}>
                <NavTabs itens={data} />
            </div>
        </>
    );

    return <Sidebar current="Atividades" content={page} />;
};

export default Activities;
